import { createApiClient, createLocalStorageTokenStorage } from 'grabbitbot-legacy-ui'
import { API_BASE_URL } from '../config'

// One ApiClient + one token storage instance for the whole app — shared by
// AuthProvider, the payment client, and the screener domain client below.
// See grabbitbot-legacy-ui README "Wiring example".
export const tokenStorage = createLocalStorageTokenStorage('authToken')

export const apiClient = createApiClient({
  baseUrl: API_BASE_URL,
  getToken: () => tokenStorage.get(),
  onUnauthorized: () => tokenStorage.clear(),
  // Every answer is live account data. Without `no-store` the browser's HTTP
  // cache may re-serve a cacheable status (notably `410 Gone` for "no wallet
  // of this coin yet") for the same URL after the state has changed — the
  // first deposit of a coin would then keep showing "no wallet" (found in E2E).
  fetchImpl: (input, init) => globalThis.fetch(input, { ...init, cache: 'no-store' }),
})
